
import { FieldProps } from "@rjsf/core";
import { StatelessComponent } from "react";
import { MapAuditingField } from "../../../../@custom/sg-mapAuditing";
import AccordionItemObjectField from "./AccordionObjectField/AccordionItemObjectField";
import AccordionObjectField from "./AccordionObjectField/AccordionObjectField";
import EvaluationChecksField from "./EvaluationField/EvaluationField";
import EvaluationObjectTemplate from "./EvaluationObjectTemplate/EvaluationObjectTemplate";

export default {
    evaluation: EvaluationChecksField,
    mapAuditing: MapAuditingField as StatelessComponent<FieldProps>
};

export const ObjectFieldTemplates = {
    accordion: AccordionObjectField,
    accordionItem: AccordionItemObjectField,
    evaluation: EvaluationObjectTemplate
};